module.exports = __webpack_public_path__ + "img/yalda_yafa_yes.cddeb1b7.png";